(function(){
    angular
        .module('app')
        .directive('copyToClipboardcrm', copytoclipboardcrm);

        copytoclipboardcrm.$inject = ['$timeout'];
        function copytoclipboardcrm($timeout){
            return {
	            restrict: 'A',
	            link: function(scope, element, attrs, modelCtrl) {
	            	element.click(function () {
                    if (attrs.copyToClipboardcrm) {
                        var $temp_input = $("<input>");
                        $("body").append($temp_input);
                        $temp_input.val(attrs.copyToClipboardcrm).select();
                        document.execCommand("copy");
                        $temp_input.remove();
                    }
                });
				}
        	}
        }
})();